<template>
  <gauge v-if="ready" :name="name" :min="min" :max="max" :value="value" :infoMessage="infoMessage" />
</template>

<script>
import Gauge from '@/components/Crops/Gauge'

export default {
  name: 'gauge-card',
  props: ['data','type','infoMessage'],
  components: { Gauge },
  data() {
    return {
      name: '',
      min: 0,
      max: 0,
      value: 0,
      ready: false
    }
  },
  watch: {
    data() {
      this.generateGauge();
    }
  },
  mounted() {
    this.generateGauge();
  },
  methods: {

    sanitizeNumber(val) {
      return isFinite(val) && val !== '' ? Number(val) : '';
    },

    generateGauge() {
      this.ready = false;
      if (this.type == 'price') {
        this.name = "Margen de venta de precio";
        this.min = this.sanitizeNumber(this.data['mdv_precio_minimo']);
        this.max = this.sanitizeNumber(this.data['mdv_precio_maximo']);
        this.value = this.sanitizeNumber(this.data['mdv_precio']);
      }
      if (this.type == 'render') {
        this.name = "Margen de venta de precio";
        this.min = this.sanitizeNumber(this.data['mdv_rinde_minimo']);
        this.max = this.sanitizeNumber(this.data['mdv_rinde_maximo']);
        this.value = this.sanitizeNumber(this.data['mdv_rinde']);
      }
      if (this.type == 'rinde_equilibrio') {
        this.name = "Rinde de Equilibrio";
        this.min = this.sanitizeNumber(this.data['taco_rinde_minimo']);
        this.max = this.sanitizeNumber(this.data['taco_rinde_maximo']);
        this.value = this.sanitizeNumber(this.data['taco_rinde']);
      }
      if (this.type == 'precio_equilibrio') {
        this.name = "Precio de Equilibrio";
        this.min = this.sanitizeNumber(this.data['taco_precio_minimo']);
        this.max = this.sanitizeNumber(this.data['taco_precio_maximo']);
        this.value = this.sanitizeNumber(this.data['taco_precio']);
      }
      if (this.type == 'rinde_esperado') {
        this.name = "Rinde Esperado";
        this.min = 0;
        this.max = 100;
        this.value = this.sanitizeNumber(this.data['prob_perdida']);
      }
      this.$nextTick(function () {
        this.ready = true;
      })

    }
  }
}

</script>
